<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" :rules="rules" ref="form" label-width="130px">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="orderNumber" label="关联工单号">
              <el-input :disabled="!!planId" clearable v-model="formData.orderNumber" placeholder="请输入关联工单号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="userId" label="关联客户">
              <el-select filterable :disabled="!!planId" v-model="formData.userId" placeholder="请选择关联客户" clearable>
                <el-option v-for="(item, index) of userList" :key="index" :label="item.userName"
                           :value="item.userId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :prop="(planId && formData.orderNumber) ? '' : 'plateNumber'" label="车牌号">
              <el-select v-model="currentVehicleKey" :filterable="true" :clearable="true" placeholder="输入车牌号/姓名搜索"
                         @change="carChange">
                <el-option v-for="(item, index) of carList" :value="`${item.vehicleKey}(${item.driverName})`"
                           :label="`${item.vehicleKey}(${item.driverName})`" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="vehicleGph" label="挂车号">
              <el-input clearable :disabled="!!planId && !!formData.orderNumber" v-model="formData.vehicleGph"
                        placeholder="请输入挂车号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="driverName" label="司机姓名">
              <el-input clearable :disabled="!!planId && !!formData.orderNumber" v-model="formData.driverName"
                        placeholder="请输入司机姓名" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="driverPhone" label="司机手机号">
              <el-input clearable v-model="formData.driverPhone" placeholder="请输入司机手机号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="driverId" label="司机身份证">
              <el-input clearable v-model="formData.driverId" placeholder="请输入司机身份证" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="vehicleType" label="车辆类型">
              <el-select v-model="formData.vehicleType" disabled placeholder="请选择车辆类型" clearable>
                <el-option v-for="(item, index) of Array.from(vehicleTypeMap)" :key="index" :label="item[1]"
                           :value="item[0]"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="vehicleDateStart" label="可预约日期(开始)">
              <el-date-picker v-model="formData.vehicleDateStart" placeholder="请选择可预约日期(开始)" type="date" clearable
                              format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="vehicleDateEnd" label="可预约日期(结束)">
              <el-date-picker v-model="formData.vehicleDateEnd" placeholder="请选择可预约日期(结束)" type="date" clearable
                              format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="plannedNum" label="计划装货数量">
              <el-input :disabled="true" v-model="formData.plannedNum" placeholder="请输入计划装货数量" />
            </el-form-item>
          </el-col>
          <el-col v-if="planId" :span="12">
            <el-form-item prop="plannedDate" label="计划入场日期">
              <el-date-picker v-model="formData.plannedDate" placeholder="请选择计划入场日期" type="date" clearable
                              format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col v-if="planId" :span="12">
            <el-form-item prop="timeslotId" label="计划入场时间段">
              <div style="display: flex;align-items: center;">
                <el-select :disabled="!isSearchTime" v-model="formData.timeslotId" placeholder="请选择计划入场时间段" clearable>
                  <el-option v-for="(item, index) of timeList" :key="index"
                             :label="`(${item.isDay === '1' ? '当日' : '次日'})` + item.startTime + ' - ' + item.endTime"
                             :value="item.slotId"></el-option>
                </el-select>
                <el-tooltip style="margin-left: 5px;" class="item" effect="dark" content="选择入场时间段时请先设置车牌号，车辆类型以及计划入场日期"
                            placement="top">
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </div>
            </el-form-item>
          </el-col>
          <el-col v-if="planId" :span="12">
            <el-form-item prop="reservationStatus" label="预约状态">
              <el-select :disabled="!!planId" v-model="formData.reservationStatus" placeholder="请选择预约状态" clearable>
                <el-option v-for="(item, index) of Array.from(reservationStatusMap)" :key="index" :label="item[1]"
                           :value="item[0]"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="planId" :span="12">
            <el-form-item prop="arrivalStatus" label="到达状态">
              <el-select :disabled="!!planId" v-model="formData.arrivalStatus" placeholder="请选择到达状态" clearable>
                <el-option v-for="(item, index) of Array.from(arrivalStatusMap)" :key="index" :label="item[1]"
                           :value="item[0]"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="planId" :span="12">
            <el-form-item prop="isMeal" label="司机报餐">
              <el-select v-model="formData.isMeal" placeholder="请选择司机报餐" clearable>
                <el-option v-for="(item, index) of Array.from(isMealMap)" :key="index" :label="item[1]"
                           :value="item[0]"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="planId" :span="12">
            <el-form-item prop="arrivalTime" label="签到时间">
              <el-date-picker v-model="formData.arrivalTime" placeholder="请选择签到时间" type="datetime" clearable
                              format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="fileList" label="附件">
              <file-upload :readonly="!!planId" v-model="formData.fileList"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item prop="specList" label="品种规格">
              <el-button type="primary" size="mini" :disabled="formData.planType !== '2'"
                         @click="addSpecList">添加(散油)</el-button>
              <el-button type="primary" size="mini" :disabled="formData.planType !== '1'" @click="addSpecList">添加(非散油)</el-button>
              <span style="color: #999;" class="ml10">散油仅能添加一条，非散油可添加多条</span>

              <el-table size="mini" stripe border :data="formData.specList">
                <el-table-column prop="specId" label="品种规格">
                  <template v-slot="{ row, $index }">
                    <el-form-item :prop="`specList.${$index}.specId`" :rules="[{ required: true, message: '请选择品种规格' }]">
                      <!-- 改成只读input，点击弹窗选择，和参考代码保持一致 -->
                      <el-input readonly v-model="row.specName" @click.native="onSpecShow(row, onSpecListChange)" placeholder="请选择品种规格" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column prop="planQuantity" label="计划装货数量">
                  <template v-slot="{ row, $index }">
                    <el-form-item :prop="`specList.${$index}.planQuantity`"
                                  :rules="[{ required: true, message: '请输入装货数量' }, { pattern: validNumber3, message: '数量为数字，可保留三位小数' }]">
                      <el-input v-model="row.planQuantity" placeholder="请输入装货数量"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template v-slot="{ $index }">
                    <el-button type="danger" size="mini" @click="delSpecList($index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
              <el-button type="primary" @click="submit">提交</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>
    <!-- 规格选择弹窗组件，和参考页面保持一致 -->
    <SpecChoose :visible.sync="dialogVisible" :isBulkOil="formData.planType === '2' ? '1' : formData.planType === '1' ? '0' : ''" @select="onSpecSelect"></SpecChoose>
  </div>
</template>

<script>
import { vehicleType, reservationStatus, arrivalStatus, isMeal } from '@/utils/dict'
import { validNumber3, validIDCard, validPhoneNumber } from '@/utils/validator'
// 引入规格选择弹窗组件
import SpecChoose from '@/components/SpecChoose.vue'
export default {
  name: 'EntryPlanAdd',
  components: { SpecChoose },
  data() {
    return {
      dialogVisible: false,
      currentRow: {},
      callback: null,

      currentVehicleKey: '',
      carList: [],
      validNumber3: validNumber3,
      vehicleTypeMap: vehicleType,
      reservationStatusMap: reservationStatus,
      arrivalStatusMap: arrivalStatus,
      isMealMap: isMeal,
      specList: [],
      formData: {
        ygType: '',
        planType: '',
        orderNumber: '', // 关联工单号
        userId: '', // 关联客户id
        plateNumber: '', // 车牌号
        vehicleGph: '', // 挂车号
        driverName: '', // 司机姓名
        driverPhone: '', // 司机手机号
        driverId: '', // 司机身份证
        isMeal: '', // 司机报餐
        vehicleType: '', // 车辆类型1大车2小车
        plannedDate: '', // 计划入场日期
        timeslotId: '', // 计划入场时间段id
        timeslotVal: '', // 计划入场时间段
        reservationStatus: '', // 预约状态1待预约2已预约
        arrivalStatus: '', // 到达状态1等待中2按时到达3超时到达4未到达5无预约进场
        arrivalTime: '', // 签到时间
        vehicleDateStart: '', // 计划入场时间
        vehicleDateEnd: '', // 计划出场时间
        plannedNum: '', // 计划装货数量
        fileList: [],
        specList: []
      },
      currentSpecType: '',
      rules: {
        userId: [
          { required: true, message: '请选择关联客户' }
        ],
        vehicleType: [
          { required: true, message: '请选择车辆类型' }
        ],
        plateNumber: [
          { required: true, message: '请输入车牌号' }
        ],
        vehicleDateStart: [{ required: true, message: '请选择可预约日期(开始)' }],
        plannedNum: [
          { required: true, message: '请输入计划装货数量' },
          { pattern: validNumber3, message: '计划装货数量为数字，可保留三位小数' }
        ],
        driverPhone: [
          { pattern: validPhoneNumber, message: '请输入正确的司机手机号' }
        ],
        driverId: [
          { pattern: validIDCard, message: '请输入正确的司机身份证' }
        ],
        specList: [
          { required: true, type: 'array', message: '请添加品种规格' }
        ]
      },
      timeList: [], // 计划入场时间段列表
      userList: [] // 客户列表
    }
  },
  created() {
    if (this.planId) {
      this.loadData()
    }
    if (this.ygType) {
      this.formData.ygType = this.ygType
    }
    this.loadUserList()
    this.loadCarList()
  },
  computed: {
    ygType() {
      return this.$route.query.ygType
    },
    planId() {
      return this.$route.query.planId
    },
    isSearchTime() {
      return this.formData.plateNumber && this.formData.vehicleType && this.formData.plannedDate
    }
  },
  watch: {
    isSearchTime(val) {
      if (val) {
        this.loadTimeList()
      } else {
        this.formData.timeslotId = ''
        this.timeList = []
      }
    },
    'formData.planedDate'(val) {
      if (this.isSearchTime) {
        this.loadTimeList()
      } else {
        this.formData.timeslotId = ''
        this.timeList = []
      }
    },
    'formData.vehicleType'(val) {
      if (this.isSearchTime) {
        this.loadTimeList()
      } else {
        this.formData.timeslotId = ''
        this.timeList = []
      }
    },
    'formData.plateNumber'(val) {
      if (this.isSearchTime) {
        this.loadTimeList()
      } else {
        this.formData.timeslotId = ''
        this.timeList = []
      }
    },
    'formData.specList': {
      deep: true,
      handler() {
        console.log('变化了')
        if (this.formData.specList.every(item => validNumber3.test(item.planQuantity))) {
          this.formData.plannedNum = this.formData.specList.reduce((prev, next) => {
            return prev + parseFloat(next.planQuantity || 0)
          }, 0)
          if (this.formData.planType === '1') {
            this.formData.vehicleType = this.formData.plannedNum > 600 ? '1' : '2'
          }
        }
      }
    }
  },
  methods: {
    // ========== 新增 和参考页面一致的规格弹窗选择方法 ==========
    onSpecShow(row, callback) {
      this.dialogVisible = true
      this.currentRow = row
      this.callback = callback
    },
    onSpecSelect(data) {
      this.callback(this.currentRow, data)
    },
    onSpecListChange(row, data) {
      row.specName = data.specName
      row.specId = data.specId
    },
    // =========================================================

    carChange(val) {
      const carInfo = this.carList.find(item => item.currentVehicleKey === val)
      console.log('carInfo', carInfo)
      // 如果切换车辆
      if (carInfo && carInfo.planType !== this.formData.planType) {
        this.formData.planType = carInfo.planType
        this.formData.specList = []
        this.loadSpec()
      }
      // 如果添加的罐车类型，那车辆类型罐车
      if (this.formData.planType === '2') {
        this.formData.vehicleType = '3'
      } else {
        this.formData.vehicleType = ''
      }
      if (carInfo) {
        this.formData.plateNumber = carInfo.vehicleKey
        this.formData.driverName = carInfo.driverName
        this.formData.driverPhone = carInfo.driverMobile
        this.formData.driverId = carInfo.driverKey
        this.formData.vehicleGph = carInfo.vehicleGph
      } else {
        this.formData.plateNumber = ''
        this.formData.driverName = ''
        this.formData.driverPhone = ''
        this.formData.driverId = ''
        this.formData.vehicleGph = ''
      }
    },
    loadCarList() {
      this.$axios.get(this.$apis.carManage.selectWlVehicleInfoByPage).then(res => {
        this.carList = res.list.map(item => {
          return {
            currentVehicleKey: `${item.vehicleKey}(${item.driverName})`,
            ...item
          }
        })
      })
    },
    delSpecList(index) {
      this.formData.specList.splice(index, 1)
    },
    addSpecList() {
      if ((this.formData.planType === '2' && !this.formData.specList.length) || this.formData.planType === '1') {
        // 新增行增加specName字段（用于页面回显名称）
        this.formData.specList.push({
          specId: '',
          specName: '',
          planQuantity: ''
        })
      }
    },
    loadSpec() {
      this.$axios.get(this.$apis.grainSpecifications.selectYxOilSpecByList, {
        isBulkOil: this.formData.vehicleType === '3' ? '1' : '0'
      }).then(res => {
        this.specList = res.list || []
      })
    },
    loadUserList() {
      this.$axios.get(this.$apis.common.selectIparkUserByList, { userType: '2,3' }).then(res => {
        this.userList = res || []
      })
    },
    loadTimeList() {
      this.$axios.get(this.$apis.clyy.selectWlVehicleTimeList, {
        plateNumber: this.formData.plateNumber,
        vehicleType: this.formData.vehicleType,
        plannedDate: this.formData.plannedDate,
        planType: this.formData.planType,
        ygType: this.formData.ygType
      }).then(res => {
        this.timeList = (res || []).filter(item => item.isVehicle === '1')
        if (this.formData.timeslotId && this.formData.timeslotVal) {
          const hasVal = this.timeList.find(item => item.timeslotId === this.formData.timeslotId)
          if (!hasVal) {
            const timeStr = this.formData.timeslotVal
            const timeRegex = /\(([^)]+)\)(\d{2}:\d{2})~(\d{2}:\d{2})/
            const match = timeStr.match(timeRegex)
            console.log('match', match)
            this.timeList.unshift({
              isMeal: this.formData.isMeal,
              slotId: this.formData.timeslotId,
              isDay: match[1] === '当天' ? '1' : '2',
              startTime: match[2],
              endTime: match[3],
              isVehicle: this.formData.vehicleType
            })
          }
        }

        console.log('this.timeListthis.timeList', this.timeList)
      })
    },
    loadData() {
      this.$axios.get(this.$apis.clyy.selectWlVehiclePlanByPlanId, { planId: this.planId }).then(res => {
        this.formData = res
        this.currentVehicleKey = `${this.formData.plateNumber}(${this.formData.driverName})`
        this.loadSpec()
      })
    },
    submit() {
      this.$refs.form.validate().then(() => {
        let url = this.$apis.clyy.insertWlVehiclePlan
        if (this.planId) {
          url = this.$apis.clyy.updateWlVehiclePlan
        }
        this.$axios.post(url, this.formData).then(() => {
          this.$router.back()
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.tips {
  font-size: 12px;
  color: #333;
}

::v-deep .el-form {
  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.add-icon {
  font-size: 18px;
  color: #3458f9;
  cursor: pointer;
  font-weight: 600;
}

.del-icon {
  font-size: 18px;
  color: #f22d2d;
  cursor: pointer;
  font-weight: 600;
  margin-right: 14px;
}

.row-wrap {
  display: flex;
  flex-direction: column;
}
</style>
